<template>
  <div>
    <search-form @search="onSearch" :fields="['name', 'phone', 'email']"/>
    <div v-if="showResult" class="margin-top-2">
      <woot-tabs
        v-if="tabs.length > 0"
        :index="activeTabIndex"
        :border="false"
        class="margin-bottom-1"
        @change="onTabChange"
      >
        <woot-tabs-item
          v-for="item in tabs"
          :key="item.key"
          :name="item.name"
          :show-badge="false"
        />
      </woot-tabs>
      <search-summary-table
        v-if="tabs.length > 0 && activeTabIndex === 0"
        :summary="summary"
        :is-fetching="uiFlags.contact.isFetchingSummary"
      />
      <contacts-table
        v-else
        :contacts="contactRecords"
        :show-search-empty-state="!uiFlags.contact.isFetching && contactRecords.length === 0"
        :is-loading="uiFlags.contact.isFetching"
        :on-click-contact="redirectContact"
        :show-column-account="isAccountTypeParent"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { frontendURL } from 'dashboard/helper/URLHelper';

import ContactsTable from '../../../routes/dashboard/contacts/components/ContactsTable.vue';
import SearchForm from './SearchForm';
import SearchSummaryTable from './SearchSummaryTable';

export default {
  components: {    
    ContactsTable,
    SearchForm,
    SearchSummaryTable,
  },
  data() {
    return {      
      showResult: false,
      activeTabIndex: 1,
    };
  },  
  computed: {
    ...mapGetters({
      contactRecords: 'conversationSearch/getContactRecords',
      uiFlags: 'conversationSearch/getUIFlags',
      isAccountTypeParent: 'isAccountTypeParent',
      summary: 'conversationSearch/getContactSummaryRecords',
    }),
    tabs() {
      if (!this.isAccountTypeParent) {
        return [];
      }
      return [
        { key: 'summary', name: this.$t('SEARCH.TABS.SUMMARY') },
        { key: 'results', name: this.$t('SEARCH.TABS.RESULTS') },
      ];
    },
  },  
  methods: {
    onSearch(data) {
      this.showResult = data !== null;
      if(!data || Object.keys(data).length == 0){
        this.$store.dispatch('conversationSearch/clearSearchResults', { type: 'contact' });
        return;
      }      
      const searchParams = {
        name: data.name,
        phone: data.phone,
        email: data.email,
        subaccount: data.subaccount ? data.subaccount.id : null,
      };
      this.$store.dispatch('conversationSearch/contactSearch', searchParams);
      // Na conta mãe, o resumo por subconta é carregado junto com os resultados
      if (this.isAccountTypeParent) {
        this.$store.dispatch(
          'conversationSearch/contactSearchSummary',
          searchParams
        );
      }
    },
    onTabChange(index) {
      this.activeTabIndex = index;
    },
    redirectContact(contact) {
      const url = frontendURL(`accounts/${contact.account.id}/contacts/${contact.id}`);
      if(this.$route.params.accountId != contact.account.id){
        window.location.href = url;
        return;
      }
      this.$router.push(url);      
    },
  },
};
</script>


